import script from "./UserVoucher.vue?vue&type=script&setup=true&lang=js"
export * from "./UserVoucher.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__